import {
	IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE,
	IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE,
	IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
	EDIT_PAGE_EXPERIENCE,
	IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE,
	isStop,
} from '@confluence/experience-tracker';
import { collectAll } from '@confluence/experience-tracker/entry-points/collectAll';
import type { ExperienceEvent } from '@confluence/experience-tracker';
import type { ExperienceName } from '@confluence/experience-tracker/entry-points/ExperienceName';

export const loadPanelSubExperiences: ExperienceName[] = [
	IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE,
	IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE,
	IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
];

export const abortAllLoadPanelExperiencesOnEditPageEnded =
	(experienceTracker, subExperiences: ExperienceName[]) => (event: ExperienceEvent) => {
		const editPageExperienceEnded = event.name === EDIT_PAGE_EXPERIENCE && isStop(event);
		if (editPageExperienceEnded) {
			abortAllLoadPanelExperiences(
				experienceTracker,
				subExperiences,
				`${EDIT_PAGE_EXPERIENCE} experience ended`,
			);
		}
	};

export const abortAllLoadPanelExperiences = (
	experienceTracker,
	subExperiences: ExperienceName[],
	reason: string,
) => {
	const allLoadPanelExperiences = [IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE, ...subExperiences];
	allLoadPanelExperiences.forEach((name) => {
		experienceTracker.abort({
			name,
			reason,
		});
	});
};

export const collectLoadPanelExperiences =
	(subExperiences: ExperienceName[]) => (events, experience) => {
		collectAll(subExperiences)(events, experience);
	};

export const filterSubExperiences = (isSpacePickerDisabled) => {
	if (isSpacePickerDisabled) {
		return loadPanelSubExperiences.filter(
			(subexperience) => subexperience !== IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE,
		);
	}
	return loadPanelSubExperiences;
};
